import type { GoOfflineConfig } from "../types";

export function defineOfflineConfig(config: GoOfflineConfig): GoOfflineConfig {
  return config;
}
